import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { ConfigService } from 'src/app/tools/services/config.service';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';

@Component({
    selector: 'branch-lov',
    templateUrl: './branch-lov.component.html',
    styleUrls: ['./branch-lov.component.scss']
})

export class BranchLovComponent extends GenericLovComponent {
  
  code   : string;
  name   : string;
 

    branchs            : Branch[] = [];
     columns = [
        {  prop: 'branchCode',  name: 'Code'},
        {  prop: 'name',        name: 'Name' 
        }
    ]

    constructor(
        public dialogRef: MatDialogRef<BranchLovComponent>,
        public configService            : ConfigService,
        protected controlTablesService  : ControlTablesService,
        protected toastr                : ToastrService,
        protected router                : Router,
        protected location              : Location) {
          super();
    }



//----------------------------------------------------------------------
loadData() {
      this.controlTablesService.branchsGet(this.code, this.name).then(result => {
          this.branchs = result;
      }).catch(error => {
          this.toastr.error(error);
      })
  }
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
  closeModal(branch : Branch){
    this.dialogRef.close(branch);
  }
//----------------------------------------------------------------------
}
